var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 21,
    height: 22.053,
    fill: "#fdec07"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(-906 -327)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(906 327)",
    fill: "#6b287a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(918 338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M0,19.141V4.373a1.158,1.158,0,0,0,.048-.167,3.022,3.022,0,0,1,1.695-2.4A3.267,3.267,0,0,1,3.3,1.482c.345,0,.691,0,1.053,0,0-.269,0-.5,0-.726A.676.676,0,0,1,5.008,0a.685.685,0,0,1,.669.746c0,.236,0,.472,0,.721h9.644c0-.266-.006-.519,0-.772a.676.676,0,0,1,.668-.7.666.666,0,0,1,.653.7c0,.253,0,.506,0,.8.535,0,1.039-.029,1.538.006a3.026,3.026,0,0,1,2.66,2.17c.065.226.105.46.157.69V19.141a1.219,1.219,0,0,0-.048.167,3,3,0,0,1-2.061,2.549,7,7,0,0,1-.81.2H2.92a.794.794,0,0,0-.142-.045A3.055,3.055,0,0,1,.092,19.584c-.034-.147-.062-.3-.092-.443M19.663,7.847H1.338v.29q0,5.327,0,10.654a1.785,1.785,0,0,0,1.928,1.929H17.735a1.787,1.787,0,0,0,1.927-1.931q0-5.327,0-10.654V7.847M5.678,2.814c0,.239.005.466,0,.693a.678.678,0,0,1-.659.706.667.667,0,0,1-.662-.721c0-.226,0-.451,0-.677-.492,0-.946-.033-1.393.007a1.675,1.675,0,0,0-1.6,1.6c-.051.677-.01,1.361-.008,2.041,0,.013.021.025.024.029H19.657c0-.687.028-1.352-.007-2.014A1.655,1.655,0,0,0,18.32,2.87a13.247,13.247,0,0,0-1.675-.1c0,.274,0,.493,0,.712a.668.668,0,0,1-.656.727.683.683,0,0,1-.665-.726c0-.219,0-.439,0-.673Z",
    transform: "translate(0 -0.001)",
    fill: "#fdec07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M179.517,206.589a1.36,1.36,0,1,1,1.391-1.362,1.367,1.367,0,0,1-1.391,1.362",
    transform: "translate(-169.035 -193.428)",
    fill: "#fdec07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M74.39,206.594a1.36,1.36,0,1,1,1.382-1.363,1.353,1.353,0,0,1-1.382,1.363",
    transform: "translate(-69.299 -193.433)",
    fill: "#fdec07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M284.908,206.592a1.36,1.36,0,1,1,1.379-1.341,1.36,1.36,0,0,1-1.379,1.341",
    transform: "translate(-269.028 -193.431)",
    fill: "#fdec07"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.eb786264f85828c2f9e5e81b69ab433d.svg";
export { ForwardRef as ReactComponent };